import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_48d77738 from 'nuxt_plugin_plugin_48d77738' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtsocketio_b496e9b0 from 'nuxt_plugin_nuxtsocketio_b496e9b0' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_templatesplugin42313ee2_f3269be2 from 'nuxt_plugin_templatesplugin42313ee2_f3269be2' // Source: ./templates.plugin.42313ee2.js (mode: 'client')
import nuxt_plugin_pluginutils_10f827fe from 'nuxt_plugin_pluginutils_10f827fe' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_478d05e8 from 'nuxt_plugin_pluginrouting_478d05e8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_13e92c3a from 'nuxt_plugin_pluginmain_13e92c3a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_4b427a60 from 'nuxt_plugin_gtm_4b427a60' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_googleanalytics_1bd0226c from 'nuxt_plugin_googleanalytics_1bd0226c' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_apollomodule_6cf99746 from 'nuxt_plugin_apollomodule_6cf99746' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_c75b5dbc from 'nuxt_plugin_cookieuniversalnuxt_c75b5dbc' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_datefns_33d0aa12 from 'nuxt_plugin_datefns_33d0aa12' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_fontawesome_613d353c from 'nuxt_plugin_fontawesome_613d353c' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_axios_1ecee57a from 'nuxt_plugin_axios_1ecee57a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_actioncablevue_1fa46c4a from 'nuxt_plugin_actioncablevue_1fa46c4a' // Source: ../plugins/actioncable-vue (mode: 'client')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_apollo_784ac076 from 'nuxt_plugin_apollo_784ac076' // Source: ../plugins/apollo (mode: 'all')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../plugins/click-outside.js (mode: 'client')
import nuxt_plugin_pluralizationRules_066a8e6d from 'nuxt_plugin_pluralizationRules_066a8e6d' // Source: ../plugins/pluralizationRules (mode: 'all')
import nuxt_plugin_currency_584566b6 from 'nuxt_plugin_currency_584566b6' // Source: ../plugins/utils/currency (mode: 'all')
import nuxt_plugin_dateTime_1c6c8c2f from 'nuxt_plugin_dateTime_1c6c8c2f' // Source: ../plugins/utils/dateTime (mode: 'all')
import nuxt_plugin_deserialize_2b05466b from 'nuxt_plugin_deserialize_2b05466b' // Source: ../plugins/utils/deserialize (mode: 'all')
import nuxt_plugin_formManager_4f923d96 from 'nuxt_plugin_formManager_4f923d96' // Source: ../plugins/utils/formManager (mode: 'all')
import nuxt_plugin_kbmb_1270e7c0 from 'nuxt_plugin_kbmb_1270e7c0' // Source: ../plugins/utils/kbmb (mode: 'all')
import nuxt_plugin_kwh_93749130 from 'nuxt_plugin_kwh_93749130' // Source: ../plugins/utils/kwh (mode: 'all')
import nuxt_plugin_phone_3bf5495a from 'nuxt_plugin_phone_3bf5495a' // Source: ../plugins/utils/phone (mode: 'all')
import nuxt_plugin_railsHost_54964e55 from 'nuxt_plugin_railsHost_54964e55' // Source: ../plugins/utils/railsHost (mode: 'all')
import nuxt_plugin_sortBy_48368029 from 'nuxt_plugin_sortBy_48368029' // Source: ../plugins/utils/sortBy (mode: 'all')
import nuxt_plugin_validateForm_4bd5dce4 from 'nuxt_plugin_validateForm_4bd5dce4' // Source: ../plugins/utils/validateForm (mode: 'all')
import nuxt_plugin_honeybadger_eea3aa18 from 'nuxt_plugin_honeybadger_eea3aa18' // Source: ../plugins/honeybadger (mode: 'all')
import nuxt_plugin_vuehoneybadger_28e9782d from 'nuxt_plugin_vuehoneybadger_28e9782d' // Source: ../plugins/vue-honeybadger (mode: 'client')
import nuxt_plugin_vuemask_9dbcaf6e from 'nuxt_plugin_vuemask_9dbcaf6e' // Source: ../plugins/vue-mask (mode: 'all')
import nuxt_plugin_vuematomo_4825ec29 from 'nuxt_plugin_vuematomo_4825ec29' // Source: ../plugins/vue-matomo.js (mode: 'client')
import nuxt_plugin_vuetooltip_f49054f4 from 'nuxt_plugin_vuetooltip_f49054f4' // Source: ../plugins/vue-tooltip (mode: 'all')
import nuxt_plugin_vueuuid_9db4d5d0 from 'nuxt_plugin_vueuuid_9db4d5d0' // Source: ../plugins/vue-uuid (mode: 'all')
import nuxt_plugin_groovechat_4bf59972 from 'nuxt_plugin_groovechat_4bf59972' // Source: ../plugins/groove_chat (mode: 'all')
import nuxt_plugin_vuegtag_9dc199a0 from 'nuxt_plugin_vuegtag_9dc199a0' // Source: ../plugins/vue-gtag (mode: 'client')
import nuxt_plugin_vuemultiselect_f0c5f110 from 'nuxt_plugin_vuemultiselect_f0c5f110' // Source: ../plugins/vue-multiselect (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TQVZGP')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TQVZGP&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_48d77738 === 'function') {
    await nuxt_plugin_plugin_48d77738(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_b496e9b0 === 'function') {
    await nuxt_plugin_nuxtsocketio_b496e9b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin42313ee2_f3269be2 === 'function') {
    await nuxt_plugin_templatesplugin42313ee2_f3269be2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_10f827fe === 'function') {
    await nuxt_plugin_pluginutils_10f827fe(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_478d05e8 === 'function') {
    await nuxt_plugin_pluginrouting_478d05e8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_13e92c3a === 'function') {
    await nuxt_plugin_pluginmain_13e92c3a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4b427a60 === 'function') {
    await nuxt_plugin_gtm_4b427a60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_1bd0226c === 'function') {
    await nuxt_plugin_googleanalytics_1bd0226c(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_6cf99746 === 'function') {
    await nuxt_plugin_apollomodule_6cf99746(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_c75b5dbc === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_c75b5dbc(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_33d0aa12 === 'function') {
    await nuxt_plugin_datefns_33d0aa12(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_613d353c === 'function') {
    await nuxt_plugin_fontawesome_613d353c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1ecee57a === 'function') {
    await nuxt_plugin_axios_1ecee57a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_actioncablevue_1fa46c4a === 'function') {
    await nuxt_plugin_actioncablevue_1fa46c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_apollo_784ac076 === 'function') {
    await nuxt_plugin_apollo_784ac076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluralizationRules_066a8e6d === 'function') {
    await nuxt_plugin_pluralizationRules_066a8e6d(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_584566b6 === 'function') {
    await nuxt_plugin_currency_584566b6(app.context, inject)
  }

  if (typeof nuxt_plugin_dateTime_1c6c8c2f === 'function') {
    await nuxt_plugin_dateTime_1c6c8c2f(app.context, inject)
  }

  if (typeof nuxt_plugin_deserialize_2b05466b === 'function') {
    await nuxt_plugin_deserialize_2b05466b(app.context, inject)
  }

  if (typeof nuxt_plugin_formManager_4f923d96 === 'function') {
    await nuxt_plugin_formManager_4f923d96(app.context, inject)
  }

  if (typeof nuxt_plugin_kbmb_1270e7c0 === 'function') {
    await nuxt_plugin_kbmb_1270e7c0(app.context, inject)
  }

  if (typeof nuxt_plugin_kwh_93749130 === 'function') {
    await nuxt_plugin_kwh_93749130(app.context, inject)
  }

  if (typeof nuxt_plugin_phone_3bf5495a === 'function') {
    await nuxt_plugin_phone_3bf5495a(app.context, inject)
  }

  if (typeof nuxt_plugin_railsHost_54964e55 === 'function') {
    await nuxt_plugin_railsHost_54964e55(app.context, inject)
  }

  if (typeof nuxt_plugin_sortBy_48368029 === 'function') {
    await nuxt_plugin_sortBy_48368029(app.context, inject)
  }

  if (typeof nuxt_plugin_validateForm_4bd5dce4 === 'function') {
    await nuxt_plugin_validateForm_4bd5dce4(app.context, inject)
  }

  if (typeof nuxt_plugin_honeybadger_eea3aa18 === 'function') {
    await nuxt_plugin_honeybadger_eea3aa18(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehoneybadger_28e9782d === 'function') {
    await nuxt_plugin_vuehoneybadger_28e9782d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_9dbcaf6e === 'function') {
    await nuxt_plugin_vuemask_9dbcaf6e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuematomo_4825ec29 === 'function') {
    await nuxt_plugin_vuematomo_4825ec29(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetooltip_f49054f4 === 'function') {
    await nuxt_plugin_vuetooltip_f49054f4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueuuid_9db4d5d0 === 'function') {
    await nuxt_plugin_vueuuid_9db4d5d0(app.context, inject)
  }

  if (typeof nuxt_plugin_groovechat_4bf59972 === 'function') {
    await nuxt_plugin_groovechat_4bf59972(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegtag_9dc199a0 === 'function') {
    await nuxt_plugin_vuegtag_9dc199a0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_f0c5f110 === 'function') {
    await nuxt_plugin_vuemultiselect_f0c5f110(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
